//Se crea un contexto donde se guarda las variables para abrir los componentes de editar cuando esta se encuentra en la parte de integracción.
import { createContext } from "react";

export const UsuarioContext = createContext();